'use client';
import React from 'react';
import { handlePaywallLoginRedirect } from '@benzinga/auth-ui';
import styles from './OptimizelyBanner.module.scss';

export interface OptimizelyBannerProps {
  adType: string;
  buttonText: string;
  subtitle: string;
  title: string;
  utmSource: string;
}

export const OptimizelyBanner: React.FC<OptimizelyBannerProps> = ({
  adType,
  buttonText,
  subtitle,
  title,
  utmSource,
}) => {
  const baseCheckoutUrl = 'https://www.benzinga.com/premium/ideas/benzinga-edge';
  const urlParams = new URLSearchParams({
    utm_adType: adType,
    utm_campaign: utmSource,
  });

  const bannerUrl = `${baseCheckoutUrl}?${urlParams.toString()}`;
  const handleLoginRedirect = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    handlePaywallLoginRedirect(utmSource);
  };

  return (
    <a
      className={`${styles.banner} animate-fade-up animate-delay-300 animate-once`}
      href={bannerUrl}
      rel="noreferrer"
      target="_blank"
    >
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
      <div>
        <button className={styles.button}>{buttonText}</button>
        <button className={styles.loginButton} onClick={handleLoginRedirect} type="button">
          Already a subscriber? Login here
        </button>
      </div>
    </a>
  );
};
